export const variationsReducer = (state = {}) => state;
